import { ListStyle, Pointer } from '@yleisradio/areena-types';
import classNames from 'classnames';
import React, { useState } from 'react';
import { useCards } from 'hooks/useCards';
import { useProgress } from 'hooks/useProgress';
import { getCardKey, getHistoryElapsedForCard } from 'utils/card';
import { Card } from 'components/Card';
import styles from './CardPage.module.scss';
import { GroupEngagementData } from 'components/SnowplowEngagementAnalytics/types';

type Props = {
  pageSize: number;
  pageIndex: number;
  source: Pointer;
  pageKey: string;
  listStyle: ListStyle | undefined;
  hidden?: boolean;
  filterParameters: Record<string, string>;
  activeCardIndex?: number | undefined;
  groupEngagementData: GroupEngagementData;
  totalCount: number;
};

const CardPage: React.FunctionComponent<Props> = ({
  pageIndex,
  pageSize,
  source,
  hidden,
  pageKey,
  listStyle,
  filterParameters,
  activeCardIndex,
  groupEngagementData,
  totalCount,
}) => {
  const { cards } = useCards({
    source,
    pageIndex,
    pageSize,
    filterParameters,
  });
  const { historyEntries } = useProgress(cards);
  const cardClassName = classNames(styles.listItem, hidden && styles.hidden);

  const [hiddenCards, setHiddenCards] = useState<string[]>([]);

  const hideCard = (key: string) => () =>
    setHiddenCards((prev) => [...prev, key]);

  return (
    <>
      {cards.map((card, index) => {
        const isActiveCard = activeCardIndex === index;
        const totalIndex = pageIndex * pageSize + index;
        const cardKey = getCardKey(card, totalIndex, pageKey);

        if (hiddenCards.includes(cardKey)) return null;

        return (
          <li
            className={cardClassName}
            aria-current={isActiveCard}
            aria-posinset={totalIndex + 1}
            aria-setsize={totalCount}
            key={cardKey}
          >
            <Card
              card={card}
              cardKey={cardKey}
              groupEngagementData={groupEngagementData}
              index={totalIndex}
              listStyle={listStyle}
              sizes="(min-width: 1920px) 18vw, (min-width: 1020px) 17vw, (min-width: 640px) 21vw, 35vw"
              historyElapsed={getHistoryElapsedForCard(card, historyEntries)}
              isActive={isActiveCard}
              hideCard={hideCard(cardKey)}
            />
          </li>
        );
      })}
    </>
  );
};

export default CardPage;
